// Shared navigation constants for auth redirects

"use strict";

/**
 * Home route name
 */
export const HOME_ROUTE = "home";

/**
 * List of routes that can be accessed without an account (auth flows).
 * Every other view requires a logged-in session.
 */
export const UNAUTHORIZED_ONLY_ROUTES = ["login", "forgot-password", "reset-password", "verify-email"];

/**
 * Returns true when the route belongs to the public auth flow.
 */
export function isPublicAuthRoute(name: unknown): boolean {
    return typeof name === "string" && UNAUTHORIZED_ONLY_ROUTES.includes(name);
}
